/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "./renderLanguageSelector.css";
import { AuthConsumer } from "../../AuthContext";

export function renderLanguageSelector(
  buttonOverrideStyle,
  buttonOverrideTextStyle,
) {
  function renderSelector(i18n) {
    function handleChange(e) {
      const change = e.target.value;
      i18n.changeLanguage(change);
    }

    return (
      <select
        className="renderLanguageSelector-select"
        onChange={handleChange}
        value={i18n.language}
      >
        <option value="zh">繁體中文</option>
        <option value="cn">简体中文</option>
        <option value="en">English</option>
      </select>
    );
  }

  return <AuthConsumer>{({ i18n }) => renderSelector(i18n)}</AuthConsumer>;
}
